module.exports = __webpack_public_path__ + "static/media/h.54bad0b8.png";